import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useForm } from "../../hooks/useForm";
import {
  cargarDatosProceso,
  cargarParticipante,
  cargarHistorial,
  cargarPrecalificador,
  cargarOfficer,
} from "../../utils/Datos";
import { PlaceholderColumnas } from "../Otros/Placeholder";

export const InformacionFuncionario = ({
  id_participant = null,
  boton_historial = true,
}) => {
  const [cargandoDatos, setCargandoDatos] = useState(true);

  const [valoresForm, handleInputChange, reset, updateValue, updateState] =
    useForm({
      id_officer: "",
      id_officer_cas: "",
      officerRut: "",
      id_profile: "",
      officerName: "",
      typeOfContract: "",
      officerGrade: "",
      dateOfBirth: "",
      dateOfEntry: "",
      email: "",
      status: "",
      id_municipalOffice: "",
      id_unit: "",
      name_management: "",
      name_unit: "",
      scale_officer: "",
      name_boss_unit: "",
      prequalifier: "",
      proceso: "",
      annoProceso: "",
    });
  const {
    proceso,
    annoProceso,
    prequalifier,
    id_officer,
    id_officer_cas,
    officerRut,
    id_profile,
    officerName,
    typeOfContract,
    officerGrade,
    dateOfBirth,
    dateOfEntry,
    email,
    status,
    id_municipalOffice,
    id_unit,
    name_management,
    name_unit,
    scale_officer,
    name_boss_unit,
  } = valoresForm;

  const [datosHistorial, setdatosHistorial] = useState(null);

  useEffect(() => {
    cargarParticipante(id_participant)
      .then((participante) => {
        if (participante != null) {
          cargarDatosProceso(participante.id_process).then((process) => {
            if (process != null) {
              updateState([
                { name: "proceso", value: process.name },
                { name: "annoProceso", value: process.yearProcess },
              ]);
            }
          });

          cargarPrecalificador(participante.id_prequalifiers).then(
            (precalificador) => {
              if (precalificador !== null) {
                updateState([
                  {
                    name: "prequalifier",
                    value: precalificador.officer.name_officer,
                  },
                ]);
              }
            }
          );

          cargarOfficer(participante.id_officer).then((datos) => {
            updateState([
              { name: "id_officer", value: datos.id_officer },
              { name: "id_officer_cas", value: datos.id_officer_cas },
              { name: "officerRut", value: datos.officerRut },
              { name: "id_profile", value: datos.id_profile },
              { name: "officerName", value: datos.officerName },
              { name: "typeOfContract", value: datos.typeOfContract },
              { name: "officerGrade", value: datos.gradeOfficer },
              { name: "dateOfBirth", value: datos.dateOfBirth },
              { name: "dateOfEntry", value: datos.dateOfEntry },
              { name: "email", value: datos.email },
              { name: "status", value: datos.status },
              { name: "id_municipalOffice", value: datos.id_municipalOffice },
              { name: "id_unit", value: datos.id_unit },
              { name: "name_management", value: datos.name_management },
              { name: "name_unit", value: datos.name_unit },
              { name: "scale_officer", value: datos.scale_officer },
              { name: "name_boss_unit", value: datos.name_boss_unit },
            ]);
          });
        } else {
        }
      })
      .then(() => {
        setCargandoDatos(false);
      });

    if (boton_historial == true) {
      cargarHistorial(id_participant).then((datos) => {
        setdatosHistorial(datos);
      });
    }
  }, [id_participant]);

  return (
    <div className="col-xl-12">
      <div className="card">
        <div className="card-header">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label fw-bolder text-dark">
               INFORMACIÓN DEL/LA FUNCIONARIO/A
            </span>
          </h3>
          <div className="card-toolbar">
            {boton_historial ? (
              <button
                className="btn btn-sm btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#m-"
              >
                 Ver historial de participación
              </button>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="card-body">
          {cargandoDatos ? (
            <div className="row">
              <div className="col-12">
                <PlaceholderColumnas
                  columnas={3}
                  filas={4}
                ></PlaceholderColumnas>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-lg-4 col-sm-12">
                <label>Proceso de calificación</label>
                <input
                  type="text"
                  className="form-control mb-5"
                  placeholder="Proceso de calificación Anual 2022"
                  disabled="disabled"
                  value={proceso}
                />
              </div>
              <div className="col-lg-4 col-sm-12">
                <label>Año del proceso</label>
                <input
                  type="text"
                  className="form-control mb-5"
                  placeholder="Proceso de calificación Anual 2022"
                  disabled="disabled"
                  value={annoProceso}
                />
              </div>
              <div className="col-lg-4 col-sm-12"></div>
              <div className="col-lg-4 col-sm-12">
                <label>Funcionario</label>
                <input
                  type="text"
                  className="form-control mb-5"
                  placeholder=""
                  value={officerName}
                  disabled="disabled"
                />
              </div>
              <div className="col-lg-4 col-sm-12">
                <label>RUT Funcionario</label>
                <input
                  type="text"
                  className="form-control mb-5"
                  value={officerRut}
                  disabled="disabled"
                />
              </div>
              <div className="col-lg-4 col-sm-12"></div>
              <div className="col-lg-4 col-sm-12">
                <label>Dirección</label>
                <input
                  type="text"
                  className="form-control mb-5"
                  value={name_management}
                  disabled="disabled"
                />
              </div>
              <div className="col-lg-4 col-sm-12">
                <label>Unidad</label>
                <input
                  type="text"
                  className="form-control mb-5"
                  placeholder=""
                  value={name_unit !== null ? name_unit : "-"}
                  disabled="disabled"
                />
              </div>
              <div className="col-lg-4 col-sm-12">
                <label>Precalificador</label>
                <input
                  type="text"
                  className="form-control mb-5"
                  placeholder=""
                  value={prequalifier}
                  disabled="disabled"
                />
              </div>

              <div className="col-lg-4 col-sm-12">
                <label>Cargo</label>
                <input
                  type="text"
                  className="form-control mb-5"
                  placeholder=""
                  value={`SIN DATO`}
                  disabled="disabled"
                />
              </div>
              <div className="col-lg-4 col-sm-12">
                <label>Escalafón</label>
                <input
                  type="text"
                  className="form-control mb-5"
                  placeholder=""
                  value={scale_officer !== null ? scale_officer : "-"}
                  disabled="disabled"
                />
              </div>
              <div className="col-lg-4 col-sm-12">
                <label>Grado</label>
                <input
                  type="text"
                  className="form-control mb-5"
                  placeholder=""
                  value={officerGrade !== null ? officerGrade : "-"}
                  disabled="disabled"
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <div
        className="modal fade"
        id="m-"
        role="dialog"
        aria-labelledby="modelTitleId"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h2 className="modal-title">
                 Ver historial de Parcipación en el proceso
              </h2>
              <div
                className="btn btn-sm btn-icon btn-active-color-primary"
                data-bs-dismiss="modal"
              >
                <span className="svg-icon svg-icon-1 ">
                  <svg
                    xmlns="http://www.w3.org/2000/svg "
                    width="24 "
                    height="24 "
                    viewBox="0 0 24 24 "
                    fill="none "
                  >
                    <rect
                      opacity="0.5 "
                      x="6 "
                      y="17.3137 "
                      width="16 "
                      height="2 "
                      rx="1 "
                      transform="rotate(-45 6 17.3137) "
                      fill="currentColor "
                    ></rect>
                    <rect
                      x="7.41422 "
                      y="6 "
                      width="16 "
                      height="2 "
                      rx="1 "
                      transform="rotate(45 7.41422 6) "
                      fill="currentColor "
                    ></rect>
                  </svg>
                </span>
              </div>
            </div>
            <div className="modal-body">
              {datosHistorial === null ? (
                <>
                  <div className="alert alert-warning" role="alert">
                    <strong>Atención,</strong> este participante no tiene
                    historial.
                  </div>
                </>
              ) : (
                <div className="row">
                  <div className="col-md-12">
                    <table className="table table-rounded table-striped border gy-7 gs-7">
                      <thead>
                        <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                          <th>ID</th>
                          <th>Nombre</th>
                          <th>Acción</th>
                          <th>Comentario</th>
                          <th>Fecha</th>
                          <th>Usuario</th>
                        </tr>
                      </thead>
                      <tbody>
                        {datosHistorial.map((dato, index) => {
                          return (
                            <tr key={`tr_${index}`}>
                              <td>{dato.id_historyOfParticipation}</td>
                              <td>{dato.userCreator}</td>
                              <td>{dato.action}</td>
                              <td>{dato.comment}</td>
                              <td>{dato.dateCreation}</td>
                              <td>{dato.userCreator}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
